module.exports = "https://p.cds.unp.clasificados.pe/logo-depor-dark-grey.457190972b6d5cfdfac657397513cada.svg";